module.exports = __webpack_public_path__ + "img/waistband elastic length.0899874b.png";